var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n  Tool page for administration of wenewz, May be integrated as a component later.. Will see.\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }